module.exports = __webpack_public_path__ + "img/level_2.c7fbb611.svg";